import { useState } from "react";
import "./style.scss";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

interface InputProps {
    label?: string;
    direction?: "row" | "column";
    value: string;
    placeholder?: string;
    id?: string;
    wrapperClassName?: string;
    className?: string;
    wrapperStyle?: React.CSSProperties;
    style?: React.CSSProperties;
    filter?: RegExp;
    callback: (value: string) => void;
    onClick?: () => void;
    error?: { isError: boolean; message?: string };
    disabled?: boolean;
    readOnly?: boolean;
}

const Input = ({
    label,
    direction,
    value,
    placeholder,
    id,
    wrapperClassName,
    className,
    wrapperStyle,
    style,
    filter,
    callback,
    onClick,
    error,
    disabled,
    readOnly
}: InputProps) => {
    const { t } = useTranslation();

    const [errorState] = useState<string>(error?.message || "");

    const inputWrapperClass = classNames("input-wrapper", {
        [`direction-${direction}`]: direction,
        [`${wrapperClassName}`]: wrapperClassName
    });

    const inputClass = classNames("oliver-input", {
        ["input-error"]: error?.isError,
        [`${className}`]: className
    });

    const handleInput = (e: React.FormEvent<HTMLInputElement>) => {
        const newInput = e.currentTarget.value;
        if (filter) {
            if (filter.test(newInput)) {
                callback(newInput);
            }
        } else {
            callback(newInput);
        }
    };
    return (
        <label className={inputWrapperClass} style={wrapperStyle}>
            {label && t("generalComponents.input." + label)}
            <input
                type="text"
                id={id}
                className={inputClass}
                style={style}
                placeholder={placeholder && t("generalComponents.input." + placeholder)}
                value={value}
                onInput={handleInput}
                onClick={onClick}
                disabled={disabled}
                readOnly={readOnly}
            />
            {error?.isError && !disabled ? <span>{errorState}</span> : ""}
        </label>
    );
};

export default Input;
